import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'
import FormErrorMessage from '../FormErrorMessage'
import FormHelpText from '../FormHelpText'
import { resizeTextarea } from '../../helpers/formHelpers'
import styles, { wrapperTheme, textareaSize, textareaResize } from './styles'

class Textarea extends Component {
  componentDidMount() {
    const value = this.props.input.value || this.props.value

    // If the reference exists and the field starts with a value, resize.
    if (value && this.textarea) {
      resizeTextarea(this.textarea)
    }
  }

  componentDidUpdate(prevProps) {
    const value = this.props.input.value || this.props.value
    const prevValue = prevProps.input.value || prevProps.value

    // If the reference exists and the value has changed, resize.
    if (this.textarea && value !== prevValue) {
      resizeTextarea(this.textarea)
    }
  }

  onKeyDown = ev => {
    const handler = this.props.onKeyDown
    if (handler) handler(ev)
  }

  onChange = ev => {
    const handler = this.props.input.onChange || this.props.onChange
    if (handler) handler(ev)
  }

  onFocus = ev => {
    const focusHandler = this.props.input.onFocus || this.props.onFocus
    if (focusHandler) focusHandler(ev)
  }

  onBlur = ev => {
    const blurHandler = this.props.input.onBlur || this.props.onBlur
    if (blurHandler) blurHandler(ev)
  }

  render() {
    const { input, meta, size, theme, className, autosize, helpText, innerRef, ariaDescribedby, ...props } = this.props

    const value = input.value || props.value || ''
    const errored = meta.touched && meta.error

    return (
      <div className={cx(styles.container, className)} onScroll={ev => ev.stopPropagation()}>
        <div className={cx(styles.wrapper, wrapperTheme(theme), errored && styles.wrapperError)}>
          <textarea
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...input}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...props}
            ref={el => {
              this.textarea = el
              if (innerRef) innerRef(el)
            }}
            value={value}
            tabIndex={props.readOnly ? '-1' : props.tabIndex}
            className={cx(styles.textarea, textareaSize(size), textareaResize(autosize))}
            onClick={ev => resizeTextarea(ev.target)}
            onKeyDown={this.onKeyDown}
            onChange={this.onChange}
            onFocus={this.onFocus}
            onBlur={this.onBlur}
            aria-describedby={ariaDescribedby}
          />
        </div>
        {Boolean(helpText && !errored) && <FormHelpText text={helpText} />}
        {Boolean(errored) && <FormErrorMessage text={meta.error} />}
      </div>
    )
  }
}

Textarea.propTypes = {
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
  input: PropTypes.shape({
    value: PropTypes.string,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
  }),
  value: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  helpText: PropTypes.string,
  tabIndex: PropTypes.string,
  readOnly: PropTypes.bool,
  theme: PropTypes.oneOf(['', 'primary', 'secondary', 'success', 'warning', 'error', 'legacy', 'dark', 'tertiary', 'info']),
  size: PropTypes.oneOf(['', 'default', 'small', 'medium', 'large']),
  autosize: PropTypes.bool,
  autoFocus: PropTypes.bool,
  className: PropTypes.string,
  innerRef: PropTypes.func,
  ariaDescribedby: PropTypes.string,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyDown: PropTypes.func,
}

Textarea.defaultProps = {
  meta: {},
  input: {},
  tabIndex: '0',
  theme: 'primary',
  size: 'default',
}

export default Textarea
